// extracted by mini-css-extract-plugin
export var arenaInfo = "arenaInfo-module--arenaInfo--ObgPT";
export var arenaInfo__arenaImage = "arenaInfo-module--arenaInfo__arenaImage--8Psnu";
export var arenaInfo__arenaInfoContainer = "arenaInfo-module--arenaInfo__arenaInfoContainer--gX+9d";
export var arenaInfo__arenaOverview = "arenaInfo-module--arenaInfo__arenaOverview--MI1Mg";
export var arenaInfo__background = "arenaInfo-module--arenaInfo__background--8kwCW";
export var arenaInfo__columnCta = "arenaInfo-module--arenaInfo__columnCta---JXTM";
export var arenaInfo__container = "arenaInfo-module--arenaInfo__container--xaWAI";
export var arenaInfo__info = "arenaInfo-module--arenaInfo__info--nFupN";
export var arenaInfo__priceList = "arenaInfo-module--arenaInfo__priceList--lfHe3";
export var arenaInfo__priceListHeader = "arenaInfo-module--arenaInfo__priceListHeader--Q8Dor";
export var arenaInfo__priceListPrice = "arenaInfo-module--arenaInfo__priceListPrice--ssOIV";
export var arenaInfo__priceListPriceReduced = "arenaInfo-module--arenaInfo__priceListPriceReduced--8qADO";
export var arenaInfo__priceListRow = "arenaInfo-module--arenaInfo__priceListRow--82nC8";